module.exports = __webpack_public_path__ + "media/images/footer/twitter-3aaad4e3d9ed9633ccd895bc6aac0d68.svg";